
/*
 *   File : select-box.js
 *   Author : https://evoqins.com
 *   Description : select box component
 *   Integrations : react-select
 *   Version : 1.0.0
*/

// packages
import React, { memo } from 'react';
import Select, { components } from "react-select";

//Custom components

import style from "../../Style/Components/input.module.scss";

const CustomSelectBox = memo((props) => {

    // handle select 
    const _handleSelectChange = (selected) => {
        props.onChange(selected);
    };

    // Custom style
    const CUSTOM_STYLES = {
        container: (defaultStyles, state) => ({
            ...defaultStyles,
            width: "100%",
            '&:focus-visible': {
                outline: 'none'
            }
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            margin: "0",
            fontFamily: "Montserrat",
            fontSize: "14px",
            color: "#808389",
            fontWeight: "500",
            textAlign: "left",
        }),
        menuList: (defaultStyles) => ({
            ...defaultStyles,
            padding: '0',
            maxHeight: '11.25rem',
            fontWeight: "500",

            '&::-webkit-scrollbar-thumb': {
                background: "#1d2e99",
                borderRadius: "0.25rem",
            },

            '&::-webkit-scrollbar': {
                width: "0.25rem",
                display: "block",
            }
        }),
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            width: "100%",
            borderRadius: "0.5rem",
            border: state.selectProps.menuIsOpen ? `1px solid #1d2e99` : `1px solid #E2E2E2`,
            backgroundColor: "#FFFFFF",
            boxShadow: "none",
            overflow: "hidden",
            paddingInline: "1rem",
            "&:hover": {
                cursor: 'pointer',
            },

            minHeight:"48px",
            fontFamily: "Montserrat",
            fontSize: "14px",
            color: "#090B0B",


        }),
        singleValue: (defaultStyles, state) => ({
            ...defaultStyles,
            textAlign: "left",
            color: "#090B0B",
            fontFamily: "Montserrat",
            fontSize: "14px",
            // lineHeight: "1.5rem",
            fontWeight: "500"

        }),
        valueContainer: (defaultStyles) => ({
            ...defaultStyles,
            padding: "0rem",

        }),

        menu: (defaultStyles) => ({
            ...defaultStyles,
            left: "0",
            boxShadow: "0 4px 12px rgba(80, 102, 249, 0.25)",
            borderRadius: "0.5rem",
            zIndex: 9999,
            width: "100%",
            padding: '0.5rem 0',
            // position: "relative",
        }),

        dropdownIndicator: (defaultStyles, state) => ({
            ...defaultStyles,
            padding: "0",
            transition: "transform 0.3s",
            transform: state.selectProps.menuIsOpen === true && "rotate(180deg)"
        }),
        option: (defaultStyles, state) => {
            return {
                ...defaultStyles,
                fontFamily: "Montserrat",
                fontSize: "14px",
                lineHeight: "1.25rem",
                padding: '0.75rem 1rem ',
                textAlign: "left",
                borderBottom: state.data.is_last ? "" : `0.063rem solid #FFFFFF`,
                backgroundColor: state.isSelected ? `#1d2e99` : `#FFFFFF`,
                color: state.isSelected ? "#FFFFFF" : "#090B0B",

                "&:hover": {
                    backgroundColor: state.isSelected ? "#1d2e99" : "#1d2e99",
                    color: state.isSelected ? "#FFFFFF" : "#FFFFFF",
                    cursor: state.isSelected ? "default" : "pointer"
                },
            };
        },
    };

    // dropdown arrow
    const DropdownIndicator = (dropdown) => {
        return (
            <>
                <components.DropdownIndicator {...dropdown}>
                    {dropdown.selectProps.loader === true ?
                        <div className="spinner-border border-2 e-text-blue-violet w-12px h-12px" role="status"></div> //loader
                        :
                        // <Icon icon='dropdown'
                        //     size={20}
                        //     className='d-flex z-3'
                        // />

                        <img src={require("../../Assets/Images/dropdown.svg").default}
                            draggable={false}
                            alt='dropdown' />
                    }
                </components.DropdownIndicator>
            </>
        );
    };


    return (
        <div className={`position-relative`}>
            {props.label &&
                <label className={`${style.e_label} pb-2`}>
                    {props.label}
                    {props.required &&
                        <span className='color-carmine-pink'>*</span>
                    }
                </label>
            }

            <Select value={props.value}
                isDisabled={props.isDisabled}
                options={props.options}
                type={props.type}
                loader={props.loader}
                isMulti={props.isMulti}
                menuPortalTarget={document.body}
                isSearchable={props.isSearchable}
                menuIsOpen={props.menuIsOpen}
                // menuIsOpen={true}
                placeholder={props.placeholder || "Select..."}
                styles={CUSTOM_STYLES}
                onMenuOpen={props.onMenuOpen}
                onMenuClose={props.onMenuClose}
                components={{
                    DropdownIndicator,
                    IndicatorSeparator: null,
                    ...(props.CustomOption && { Option: props.CustomOption })
                }}
                // onInputChange={_handleInputChange}
                onChange={_handleSelectChange}
            />

            {props.error &&
                <p className={style.e_error_message}>
                    {props.error}
                </p>
            }
        </div>
    );
});

export default CustomSelectBox;
